import { render } from "./IdentityVerification.vue.ts?vue&type=template&id=f4fc9b7a&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IdentityVerification.vue?vue&type=template&id=f4fc9b7a&ts=true"
import script from "./IdentityVerification.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IdentityVerification.vue?vue&type=script&lang=ts&setup=true"
export * from "./IdentityVerification.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IdentityVerification.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/credit-line/components/Withdrawal/IdentityVerification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f4fc9b7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f4fc9b7a', __exports__)) {
    api.reload('f4fc9b7a', __exports__)
  }
  
  module.hot.accept("./IdentityVerification.vue.ts?vue&type=template&id=f4fc9b7a&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IdentityVerification.vue?vue&type=template&id=f4fc9b7a&ts=true", () => {
    api.rerender('f4fc9b7a', render)
  })

}


export default __exports__